import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaselinkerService {

  constructor(private httpClient: HttpClient) { }
  public getToken(): Observable<any> {
    return this.httpClient.get(environment.gatewayUrl + `api-keys/`);
  }
  public refreshToken(): Observable<any> {
    return this.httpClient.post(environment.gatewayUrl + `api-keys/`, {});
  }
}
